var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"custom-marker"},[_c('div',{staticClass:"content-area"},[_c('span',{staticClass:"text-primary cursive mb-0 nowrap",staticStyle:{"cursor":"pointer!important"}},[_vm._v(_vm._s(_vm.value.substring(0, 50)))])]),_vm._v(" "),_c('div',{staticClass:"square"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f40b742","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/front/components/widgets/common/google-map/CustomGenericMarker.vue
// module id = null
// module chunks = 